import { AloJwt } from '@/models/alo/AloJwt'
import { AloUser } from '@/models/alo/AloUser'

export class AloIdentityToken {    

    public aloJwt:AloJwt
    public aloUser:AloUser
    public wsUrl:String

    constructor({aloJwt=null,aloUser=null,wsUrl=''}:{aloJwt?:any,aloUser?:any,wsUrl?:string} = {}) {                
        this.aloJwt = new AloJwt(aloJwt)
        this.aloUser = new AloUser(aloUser)
        this.wsUrl = wsUrl
    }

    static createAloIdentityToken(data:any) {
        return new AloIdentityToken(data) 
    }
    
    static createReadOnlyAloIndentityToken(data:any) {
        return Object.freeze(new AloIdentityToken(data))
    }
}